<template>

  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>Reservar varios turnos</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>

      <v-container>
        <h4
          v-if="mostrarGuardar"
          class="violeta"
        >Usted tiene {{detalleTurno.turnosDisponibles}} turnos disponibles.</h4>
        <h6
          v-if="mostrarGuardar"
          class="verde"
        >Indique la cantidad de turnos que desea solicitar para este mismo día de la semana y horario (la práctica seleccionada admite hasta {{turnosRecurrentes}} turnos).</h6>
        <v-row v-if="mostrarGuardar">
          <v-flex
            xs12
            sm12
          >
            <v-text-field
              v-model="altaTurno.turnos_recurrentes"
              v-validate="{required: true, max: 100 }"
              :error-messages="errors.collect('turnos_recurrentes')"
              label="Cantidad turnos"
              data-vv-name="turnos_recurrentes"
              data-vv-validate-on="none"
            ></v-text-field>
          </v-flex>

        </v-row>
        <v-layout
          row
          v-if="!mostrarGuardar"
        >
          <v-flex sm12>
            <v-list
              grid-list-sm
              v-if="turnosConseguidos.length > 0"
            >
              <h6 class="verde">Detalle de turnos conseguidos</h6>
              <template v-for="(item, index) in turnosConseguidos">
                <v-list-tile
                  :key="item.fecha"
                  sm6
                >
                  <v-list-tile-action>
                    <v-icon color="green">check</v-icon>

                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{nombreDia(item)}} - {{item.fecha | formatoFecha}} - {{horaDesde(item)}}hs</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="index"></v-divider>
              </template>
            </v-list>
            <v-list
              grid-list-sm
              v-if="turnosNoDisponibles.length > 0"
            >
              <h6 class="verde">Detalle de turnos no disponibles</h6>
              <template v-for="(item, index) in turnosNoDisponibles">
                <v-list-tile
                  :key="item.fecha"
                  sm6
                >
                  <v-list-tile-action>
                    <v-icon color="red">cancel</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{nombreDia(item)}} - {{item.fecha | formatoFecha}} - {{horaDesde(item)}}hs</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="index"></v-divider>
              </template>
            </v-list>
          </v-flex>

        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <botones-cancelar-guardar
          v-bind:mostrar-guardar="mostrarGuardar"
          v-bind:mostrar-cancelar="mostrarGuardar"
          v-bind:guardando="guardando"
          v-on:alGuardar="guardarAdjunto"
          v-on:alCancelar="cerrar"
          v-if="!subiendo"
        ></botones-cancelar-guardar>
        <v-btn
          color="primary"
          small
          flat
          :class="{ 'btn-guardar': true }"
          @click="cerrarTurno"
          v-if="!mostrarGuardar"
        >Cerrar</v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>
<script>
import mixinAbm from '@/mixins/abm'
import abmFormularioMixin from '@/mixins/abmFormulario'
import abmListadoMixin from '@/mixins/abmListado'
import Agenda from '@/api/agenda'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'TurnoOrden',
  props: {
    agendaId: {
      type: Number,
      defualt: 0
    },
    altaTurno: {
      type: Object,
      defualt: null
    },
    detalleTurno: {
      type: Object,
      defualt: null
    },
    turnosRecurrentes: {
      type: Number,
      default: null
    }
  },
  mixins: [mixinAbm, abmFormularioMixin, abmListadoMixin],
  computed: {
    configuracion () {
      return this.$store.getters.app
    },
    usuario () {
      return this.$store.getters.getUser
    },
    functionEvents () {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    turnosConseguidos () {
      console.log(_.filter(this.turnosDisponibles, item => {
        return item.obtenido === false
      }))
      return _.filter(this.turnosDisponibles, item => {
        return item.obtenido === true
      })
    },
    turnosNoDisponibles () {
      console.log(_.filter(this.turnosDisponibles, item => {
        return item.obtenido === false
      }))
      return _.filter(this.turnosDisponibles, item => {
        return item.obtenido === false
      })
    }
  },
  data () {
    return {
      cargando: true,
      guardando: false,
      buscando: false,
      mostrarGuardar: true,
      turnosDisponibles: [],
      info: {
        dias: [
          {
            'id': 1,
            'nombre': 'Lunes'
          },
          {
            'id': 2,
            'nombre': 'Martes'
          },
          {
            'id': 3,
            'nombre': 'Miércoles'
          },
          {
            'id': 4,
            'nombre': 'Jueves'
          },
          {
            'id': 5,
            'nombre': 'Viernes'
          },
          {
            'id': 6,
            'nombre': 'Sábado'
          },
          {
            'id': 7,
            'nombre': 'Domingo'
          }
        ]
      }
    }
  },
  mounted () {
    console.log(this.altaTurno)
  },
  methods: {
    nombreDia (item) {
      let vm = this
      const date = moment(item.fecha)
      const dow = date.day()
      let dia = vm.info.dias.filter(c => c.id === parseInt(dow))

      return dia[0].nombre
    },
    horaDesde (item) {
      return moment(item.fecha).format('HH:mm')
    },
    cerrarTurno () {
      this.$emit('alCerrarTurno', null)
    },
    guardarAdjunto () {
      let vm = this

      if (vm.detalleTurno.turnosDisponibles < vm.altaTurno.turnos_recurrentes) {
        vm.guardando = false
        vm.mostrarError({ message: 'Puede solicitar hasta ' + vm.detalleTurno.turnosDisponibles + ' turnos.' }, true)
        return false
      }

      if (vm.turnosRecurrentes < vm.altaTurno.turnos_recurrentes) {
        vm.guardando = false
        vm.mostrarError({ message: 'La practica adminite hasta ' + vm.turnosRecurrentes + ' turnos recurrentes.' }, true)
        return false
      }

      vm.altaTurno.id = vm.agendaId
      vm.guardando = true
      if (vm.altaTurno.turnos_recurrentes !== null && vm.altaTurno.turnos_recurrentes > 0) {
        Agenda.obtenerTurnosRecurrentes(vm.altaTurno).then(
          data => {
            vm.turnosDisponibles = data
            vm.mostrarGuardar = false
            vm.mostrarMensajeOk()
            vm.guardando = false
          },
          error => {
            vm.guardando = false
            vm.mostrarError(error, true)
          }
        )
      } else {
        vm.guardando = false
        vm.mostrarError({ message: 'Por favor complete todos los campos' }, true)
      }
    },
    puedoGuardarEstudio () {
      return !this.subiendo
    }
  }
}
</script>

<style lang="scss" scoped>
dt {
  font-weight: 100;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.btn-guardar {
  background-color: #5e4295 !important;
  border-color: #604492 !important;
  border-radius: 15px;
  min-height: 30px;
  color: #ffffff !important;
  border: 2px solid;
}
.v-tabs__wrapper {
  background-color: #e41b23 !important;
}
.v-btn--full {
  width: 100%;
  cursor: pointer !important;
}
h5 {
  padding-top: 10px;
}
.spinner {
  padding-top: 70px;
}
.blanco {
  color: #ffffff;
  font-weight: 100 !important;
}
.card {
  min-height: 180px;
}
/* width */
::-webkit-scrollbar {
  width: 12px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.violeta {
  color: #7158a1;
}
.verde {
  color: #06cbb3;
}
h6 {
  font-weight: 100;
  margin-bottom: 0.2rem;
  margin-top: 0.6rem;
}
.v-divider {
  margin: 2px;
}
</style>
